import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2UpdateParams,
  IIndirectTaxFilingV2UpdateResponse,
} from './types';

export async function updateIndirectTaxFilingV2({
  filingId,
  params,
  token,
}: {
  filingId: string;
  params: IIndirectTaxFilingV2UpdateParams;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2UpdateResponse>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}`,
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to update filing',
      };
    }
    const data: IIndirectTaxFilingV2UpdateResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to update filing',
    };
  }
}
